export const SEGMENTS_PREFIX = 'segments/';

export const USER_SEGMENTS_REQUESTED = `${SEGMENTS_PREFIX}USER_SEGMENTS_REQUESTED`;

export const MORE_USER_SEGMENTS_REQUESTED = `${SEGMENTS_PREFIX}MORE_USER_SEGMENTS_REQUESTED`;

export const USER_SEGMENTS_SUCCEEDED = `${SEGMENTS_PREFIX}USER_SEGMENTS_SUCCEEDED`;

export const USER_SEGMENTS_FAILED = `${SEGMENTS_PREFIX}USER_SEGMENTS_FAILED`;

export const SEGMENT_TAGS_REQUESTED = `${SEGMENTS_PREFIX}SEGMENT_TAGS_REQUESTED`;

export const SEGMENT_TAGS_SUCCEEDED = `${SEGMENTS_PREFIX}SEGMENT_TAGS_SUCCEEDED`;

export const SEGMENT_TAGS_FAILED = `${SEGMENTS_PREFIX}SEGMENT_TAGS_FAILED`;

export const SET_ACTIVE_SEGMENT = `${SEGMENTS_PREFIX}SET_ACTIVE_SEGMENT`;

export const RESET_USER_SEGMENTS = `${SEGMENTS_PREFIX}RESET_USER_SEGMENTS`;

export const RESET_USER_SEGMENTS_TAGS = `${SEGMENTS_PREFIX}RESET_USER_SEGMENTS_TAGS`;

export const SEGMENT_PHOTOS_REQUESTED = `${SEGMENTS_PREFIX}SEGMENT_PHOTOS_REQUESTED`;

export const SEGMENT_PHOTOS_SUCCEEDED = `${SEGMENTS_PREFIX}SEGMENT_PHOTOS_SUCCEEDED`;

export const SEGMENT_PHOTOS_FAILED = `${SEGMENTS_PREFIX}SEGMENT_PHOTOS_FAILED`;

export const UPDATE_SEGMENT_NOTES_REQUESTED = `${SEGMENTS_PREFIX}UPDATE_SEGMENT_NOTES_REQUESTED`;

export const UPDATE_SEGMENT_NOTES_SUCCEEDED = `${SEGMENTS_PREFIX}UPDATE_SEGMENT_NOTES_SUCCEEDED`;

export const UPDATE_SEGMENT_NOTES_FAILED = `${SEGMENTS_PREFIX}UPDATE_SEGMENT_NOTES_FAILED`;

export const UPDATE_SEGMENT_NAME_REQUESTED = `${SEGMENTS_PREFIX}UPDATE_SEGMENT_NAME_REQUESTED`;

export const UPDATE_SEGMENT_NAME_SUCCEEDED = `${SEGMENTS_PREFIX}UPDATE_SEGMENT_NAME_SUCCEEDED`;

export const UPDATE_SEGMENT_NAME_FAILED = `${SEGMENTS_PREFIX}UPDATE_SEGMENT_NAME_FAILED`;

export const DELETE_SEGMENT_REQUESTED = `${SEGMENTS_PREFIX}DELETE_SEGMENT_REQUESTED`;

export const DELETE_SEGMENT_SUCCEEDED = `${SEGMENTS_PREFIX}DELETE_SEGMENT_SUCCEEDED`;

export const DELETE_SEGMENT_FAILED = `${SEGMENTS_PREFIX}DELETE_SEGMENT_FAILED`;

export const PARTNERS_REQUESTED = `${SEGMENTS_PREFIX}PARTNERS_REQUESTED`;

export const PARTNERS_SUCCEEDED = `${SEGMENTS_PREFIX}PARTNERS_SUCCEEDED`;

export const PARTNERS_FAILED = `${SEGMENTS_PREFIX}PARTNERS_FAILED`;
